import { createRouter, createWebHistory } from 'vue-router';
import { routes } from './routes';
import { useReportsStore } from '../store/modules/reportsStore';

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard to sync store state with URL and trigger fetches
router.beforeEach((to, from, next) => {
  if (to.name === 'reports' || to.name === 'reports-subject') {
    const store = useReportsStore();
    const { formats, grades, order, dir, page } = to.query;
    const subject = to.params.subject as string | undefined;
    let stateChanged = false;

    // --- Sync State from URL --- 

    // 1. Sync Subject
    const currentSubject = store.selectedSubjects.length > 0 ? store.selectedSubjects[0] : undefined;
    if (subject && subject !== currentSubject) {
      store.setSubject(subject, true); // setSubject updates state ONLY
      stateChanged = true;
    } else if (!subject && currentSubject) {
      // Handle navigating away from a subject route back to /reports maybe?
      // Or perhaps this case isn't needed if filters handle clearing.
    }

    // 2. Sync Filters (Simplified example - Adapt if setSelectedFilters logic is complex)
    const newFormats = formats ? (Array.isArray(formats) ? formats.map(String) : [String(formats)]) : [];
    const newGrades = grades ? (Array.isArray(grades) ? grades.map(String) : [String(grades)]) : [];
    if (JSON.stringify(newFormats) !== JSON.stringify(store.selectedFormats) || 
        JSON.stringify(newGrades) !== JSON.stringify(store.selectedGrades)) {
      store.setSelectedFilters({ formats: newFormats, grades: newGrades }); // This might still fetch, review store
      stateChanged = true;
    }

    // 3. Sync Sort Option
    let targetSortOption = 'Recently Published'; // Default
    if (order && dir) {
      const optionFound = Object.entries({
        'published': 'Recently Published',
        'alpha': 'Alphabetical',
        'edition': 'Copyright'
      }).find(([key, value]) => key === order)?.[1];
      if (optionFound) {
        targetSortOption = optionFound;
      }
    }
    if (store.sortOption !== targetSortOption) {
      store.setSortOption(targetSortOption); // setSortOption updates state ONLY
      stateChanged = true;
    }

    // 4. Sync Page
    const targetPage = page ? parseInt(String(page), 10) : 1;
    if (store.currentPage !== targetPage) {
      store.setPage(targetPage); // setPage updates state ONLY (if modified in store)
      stateChanged = true;
    }
    
    // --- Trigger Fetch --- 
    // Always fetch on navigation to these routes to ensure data consistency
    // Store's internal fetchReports logic should handle cancellation/throttling
    store.fetchReports(); 

  } else {
    // If navigating away from reports, potentially clear state?
    // const store = useReportsStore();
    // store.resetFilters(); // Example action
  }

  next();
});

export default router;